import { Link } from 'react-router-dom';
import { MapPin, BedDouble, Bath, Maximize2, Car, ArrowUpRight } from 'lucide-react';
import { Badge } from './ui/badge';

export default function PropertyCard({ property }) {
  const statusColor = property.status === 'New' ? 'bg-green-600' : (property.status === 'Hot' ? 'bg-[#DC2626]' : 'bg-neutral-800');
  const isRent = property.transactionType === 'For Rent';
  const area = property.floorArea || property.lotArea || 0;
  const pricePerSqm = area > 0 && !isRent ? Math.round((property.price || 0) / area) : 0;
  const pricePerSqmLabel = pricePerSqm > 0
    ? '\u20B1 ' + pricePerSqm.toLocaleString('en-PH') + '/sqm'
    : '';

  return (
    <Link to={'/property/' + property.id} className="group block">
      <div className="card-hover bg-white rounded-lg overflow-hidden border border-neutral-200">
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={property.image}
            alt={property.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute top-3 left-3 flex gap-2">
            <Badge className={'text-white ' + statusColor + ' hover:' + statusColor}>{property.status}</Badge>
            <Badge variant="secondary" className="bg-white/95 text-neutral-900">{property.transactionType}</Badge>
          </div>
          {pricePerSqmLabel && (
            <div className="absolute top-3 right-3 px-2 py-1 rounded-md bg-black/70 backdrop-blur text-white text-[10px] font-medium">
              {pricePerSqmLabel}
            </div>
          )}
          <div className="absolute bottom-3 left-3 right-3 flex items-end justify-between gap-2">
            <div className="inline-flex px-3 py-1.5 rounded bg-black/70 backdrop-blur text-white text-sm font-semibold">
              {property.priceLabel}
            </div>
            <div className="opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 inline-flex items-center gap-1 px-3 py-1.5 rounded bg-[#DC2626] text-white text-xs font-semibold">
              View Details <ArrowUpRight className="w-3 h-3" />
            </div>
          </div>
        </div>
        <div className="p-4">
          <p className="text-xs text-[#DC2626] font-medium uppercase tracking-wide">{property.type}</p>
          <h3 className="mt-1 font-semibold text-neutral-900 line-clamp-1 group-hover:text-[#DC2626] transition-colors">
            {property.title}
          </h3>
          <p className="mt-1 flex items-center gap-1 text-sm text-neutral-500"><MapPin className="w-3.5 h-3.5" /> {property.location}</p>
          <div className="mt-3 pt-3 border-t border-neutral-100 flex items-center justify-between text-xs text-neutral-600">
            {property.bedrooms > 0
              ? <span className="flex items-center gap-1"><BedDouble className="w-4 h-4" /> {property.bedrooms} Bed</span>
              : <span className="flex items-center gap-1"><Maximize2 className="w-4 h-4" /> {property.lotArea}sqm</span>}
            {property.bathrooms > 0 && <span className="flex items-center gap-1"><Bath className="w-4 h-4" /> {property.bathrooms} Bath</span>}
            <span className="flex items-center gap-1"><Maximize2 className="w-4 h-4" /> {property.floorArea}sqm</span>
            {property.parking > 0 && <span className="flex items-center gap-1"><Car className="w-4 h-4" /> {property.parking}</span>}
          </div>
        </div>
      </div>
    </Link>
  );
}
